import { ContentSlider } from '../../shared/carousel';
import NewsItem from './NewsItem';
import NewsDetailModal from './NewsDetailModal';
import { newsInfo } from './newsSettings';


const NewsSection = (settings) => {
    return (
        <>
            <div id="news" className="py-4 news-section">
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <span className="section-title section-title-highlight fs-4 d-none d-lg-inline-block">DFC News and Articles</span>
                            <span className="section-title">News & Highlights</span>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col">
                            <span className="section-title-2 d-none d-lg-inline-block">Program News</span>
                        </div>
                    </div>
                    <div className="row mt-3">
                        <ContentSlider items={newsInfo.items}
                            itemCountToShow={3}
                            renderItemTemplate={NewsItem} />
                    </div>
                </div>
            </div>
            <NewsDetailModal />
        </>
    );
};

export default NewsSection;
